<template>

  <InfoCiclo />

</template>

<script>
import InfoCiclo from '../components/pratiche/InfoCiclo.vue'

export default {
  components: {
    InfoCiclo

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
